export interface AcademyData {
  AcademyId: string;
  Role: string;
  userId: string;
  academyName: string
}

export const ACADEMYDATA = 'ACADEMYDATA';

export const currentAcademyID = (academyData: AcademyData) => ({
  type: ACADEMYDATA,
  payload: academyData,
});
